import React from 'react';
import { AwardIcon, ClipboardListIcon, ImageIcon, LayersIcon, MonitorIcon, PrinterIcon } from 'lucide-react';
import { includedItems, type IncludedItem } from '../data/content';
import { Eyebrow } from './ui/Eyebrow';
const icons: Record<IncludedItem['icon'], typeof LayersIcon> = {
  layers: LayersIcon,
  clipboard: ClipboardListIcon,
  printer: PrinterIcon,
  award: AwardIcon,
  monitor: MonitorIcon,
  image: ImageIcon
};
export function Included() {
  return <section id="zawartosc" className="w-full bg-white" data-id="element-81" data-mp="s467lifxlmx1">
      <div className="mx-auto max-w-content px-6 py-20" data-id="element-82" data-mp="s4pk2jmtbj3o">
        <div className="text-center" data-id="element-83" data-mp="n4jud903s6o8">
          <Eyebrow data-id="element-84" data-mp="n3i96bpdi3ss">Zawartość pakietu</Eyebrow>
          <h2 className="mt-4 font-display text-[24px] font-bold leading-tight text-ink sm:text-[27px]" data-id="element-85" data-mp="i68lp1ljo27l">
            Co znajdziesz w pakiecie PLASTYKA GOTOWA™?
          </h2>
        </div>

        <ul className="mt-9 grid gap-4 sm:grid-cols-2 md:grid-cols-3" data-id="element-86" data-mp="32w7hkcpbektu">
          {includedItems.map(item => {
          const Icon = icons[item.icon];
          return <li key={item.title} className="flex h-full flex-col rounded-xl border border-sand bg-beige/60 px-4 py-5 text-center" data-id="element-87" data-mp="35pgvhd77qnqh">
                <span className="mx-auto flex h-8 w-8 items-center justify-center rounded-full bg-white text-coral" data-id="element-88" data-mp="2vsub0pistyoz">
                  <Icon className="h-4 w-4" aria-hidden="true" data-id="element-89" data-mp="30ujpkf58cuht" />
                </span>
                <h3 className="mt-3 font-display text-[13px] font-bold leading-snug text-ink" data-id="element-90" data-mp="2mzr4z2ahgo4d">
                  {item.title}
                </h3>
                <p className="mt-2 text-[11px] leading-relaxed text-muted" data-id="element-91" data-mp="2d3eai274668k">
                  {item.description}
                </p>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}